import axios from "axios";
import { getUserKYCDetailsWeb3 } from "../../../services/contracts/clientContract";
import VerifyKYC from "../../../components/popups/verifyKYC";
import { Login } from "../../../components/popups/network";
import { onAuthStateChanged } from "firebase/auth";
import { getToken } from "firebase/messaging";
import { doc, setDoc } from "firebase/firestore";
import { authenticateFirestore, initFireBase } from "../firebase";
import { hashTheString } from "@verified-network/verified-custody";
import { emailSenderUrl } from "../../constants";

export const createAccessTokenForNewUser = async (
  userAddress,
  chainId,
  isOtp,
  isTest,
) => {
  try {
    const res = await axios({
      method: "GET",
      url: isOtp
        ? `${process.env.REACT_APP_SUMSUB_ENDPOINT}?account=${userAddress}&networkId=${chainId}&isOtp=true`
        : isTest
          ? `${process.env.REACT_APP_SUMSUB_ENDPOINT}?account=${userAddress}&networkId=${chainId}&isTest=true`
          : `${process.env.REACT_APP_SUMSUB_ENDPOINT}?account=${userAddress}&networkId=${chainId}`,
    });
    if (res?.data?.token) {
      return {
        accessToken: res?.data?.token,
      };
    } else {
      return {
        accessToken: "",
      };
    }
  } catch (err) {
    console.error("error while creating access token: ", err?.message);
    return {
      accessToken: "",
    };
  }
};

export const fetchUserDetailsFromSumsub = async (applicantId) => {
  try {
    const res = await axios({
      method: "GET",
      url: `${process.env.REACT_APP_SUMSUB_ENDPOINT}?applicantId=${applicantId}`,
    });
    if (res?.data?.applicantData) {
      return res?.data?.applicantData;
    } else {
      return null;
    }
  } catch (err) {
    console.error(
      "error while fetching user details from sumsub: ",
      err?.message,
    );
    return null;
  }
};

export const authenticateKYCStatus = async (
  chainId,
  userAddress,
  web3,
  appKitModal,
  setPopupContent,
  setPopupContentPosition,
  setShowPopup,
  setCustomLoading,
  setFavouriteClicked,
  isMobileScreen,
  setVerifiedWalletDetails,
  verifiedWalletDetails,
  generalDataProps,
) => {
  let isWalletConnected = false;
  if (userAddress === "") {
    // if (window?.verifiedwallet?.request) {
    //   setCustomLoading(true);
    //   await window.verifiedwallet
    //     .request({
    //       method: "connectWallet",
    //       params: { chainId: chainDetails[0].chainId,  },
    //     })
    //     .then((res) => {
    //       setCustomLoading(false);
    //       if (res?.length > 0) {
    //         isWalletConnected = true;
    //       }
    //     });
    // } else if (isMobileScreen || useWalletInApp) {
    //   setFavouriteClicked(false);
    //   setPopupContent(
    //     <InAppWallet
    //       action="connect_wallet"
    //       origin={window.location.host}
    //       title={"Verified Network"}
    //       verifiedWalletDetails={{}}
    //       mobileScreen={isMobileScreen}
    //     />
    //   );
    //   setPopupContentPosition("center");
    //   setShowPopup(true);
    // } else {
    //   await appKitModal.open();
    // }
    if (setFavouriteClicked) {
      setFavouriteClicked(false);
    }
    setPopupContentPosition("center");
    setPopupContent(
      <Login
        setShowPopup={setShowPopup}
        setPopupContent={setPopupContent}
        setPopupContentPosition={setPopupContentPosition}
        setCustomLoading={setCustomLoading}
        setVerifiedWalletDetails={setVerifiedWalletDetails}
        verifiedWalletDetails={verifiedWalletDetails}
        generalDataProps={generalDataProps}
        mobileScreen={isMobileScreen}
      />,
    );
    setShowPopup(true);
  } else {
    isWalletConnected = true;
  }
  if (isWalletConnected) {
    const userKyc = await getUserKYCDetailsWeb3(chainId, userAddress, web3);
    if (Number(userKyc?.userKycStatus) !== 3) {
      const accessToken = await createAccessTokenForNewUser(
        userAddress,
        chainId,
      ).then((res) => res?.accessToken);
      if (setCustomLoading) {
        setCustomLoading(false);
      }
      if (setFavouriteClicked) {
        setFavouriteClicked(false);
      }
      setPopupContentPosition("center");
      setPopupContent(
        <VerifyKYC
          setShowPopup={setShowPopup}
          setPopupContent={setPopupContent}
          setPopupContentPosition={setPopupContentPosition}
          buttonAction="verify kyc"
          additionalProps={{
            accessToken,
            userAddress,
            chainId,
          }}
          generalDataProps={generalDataProps}
        />,
      );
      setShowPopup(true);
    } else {
      return true;
    }
  }
};

export const fixApplicantRejections = async (applicantId, externalUserId) => {
  if (applicantId && externalUserId) {
    try {
      const dataToReset = ["ALL"];
      const res = await axios({
        method: "POST",
        url: process.env.REACT_APP_APPROVAL_ENDPOINT,
        data: {
          applicantId,
          externalUserId,
          dataToReset,
        },
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (res?.data?.link?.length > 0) {
        return res?.data?.link;
      } else {
        return "";
      }
    } catch (err) {
      console.log("failed: ", err?.message);
      return "";
    }
  } else {
    return "";
  }
};

export const fetchUserDetailsByExtenalUserId = async (externalUserId) => {
  try {
    const res = await axios({
      method: "GET",
      url: `${process.env.REACT_APP_SUMSUB_ENDPOINT}?externalUserId=${externalUserId}`,
    });
    if (res?.data) {
      return res?.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log("error fetching details: ", err?.message);
    return null;
  }
};

export const uploadFileToFirebase = async (
  hashedUserAddress,
  file,
  fileName,
  setUploadPercentage,
  idx,
  uploadPercentages,
) => {
  try {
    if (uploadPercentages) {
      let newPerc = uploadPercentages;
      newPerc[idx] = 0.0;
      setUploadPercentage(newPerc);
    } else {
      setUploadPercentage(0.0);
    }

    const formData = new FormData();
    formData.append("file", file, fileName);
    formData.append("type", "save_kyc_file");

    if (uploadPercentages) {
      let newPerc = uploadPercentages;
      newPerc[idx] = 10.0;
      setUploadPercentage(newPerc);
    } else {
      setUploadPercentage(10.0);
    }
    const authenticated = await authenticateFirestore(
      hashedUserAddress,
      hashTheString(""),
      process.env.REACT_APP_KYC_DB,
    );

    if (authenticated) {
      if (uploadPercentages) {
        let newPerc = uploadPercentages;
        newPerc[idx] = 25.1;
        setUploadPercentage(newPerc);
      } else {
        setUploadPercentage(25.1);
      }

      return await axios({
        url: emailSenderUrl,
        method: "POST",
        data: {
          uniqueId: authenticated,
          type: "generate",
        },
      })
        .then(async (res) => {
          if (uploadPercentages) {
            let newPerc = uploadPercentages;
            newPerc[idx] = 50.2;
            setUploadPercentage(newPerc);
          } else {
            setUploadPercentage(50.2);
          }

          if (res?.data?.token) {
            setUploadPercentage();
            if (uploadPercentages) {
              let newPerc = uploadPercentages;
              newPerc[idx] = 65.35;
              setUploadPercentage(newPerc);
            } else {
              setUploadPercentage(65.35);
            }
            return await axios({
              url: emailSenderUrl,
              method: "POST",
              headers: {
                Authorization: `Bearer ${res?.data?.token}`,
              },
              data: formData,
            })
              .then((_res) => {
                if (_res?.data?.fileUrl) {
                  if (uploadPercentages) {
                    let newPerc = uploadPercentages;
                    newPerc[idx] = 100.0;
                    setUploadPercentage(newPerc);
                  } else {
                    setUploadPercentage(100.0);
                  }

                  return _res?.data?.fileUrl;
                } else {
                  return null;
                }
              })
              .catch((err) => {
                if (process.env.REACT_APP_NODE_ENV !== "production") {
                  console.error("upload failed with error: ", err?.message);
                }

                return null;
              });
          } else {
            return null;
          }
        })
        .catch((err) => {
          if (process.env.REACT_APP_NODE_ENV !== "production") {
            console.error("upload failed with error: ", err?.message);
          }
          return null;
        });
    } else {
      return null;
    }
  } catch (err) {
    console.error("Error while uploading file:", err?.message);
    return null;
  }
};

export const getAndSaveTokenKyc = async (hashedVaultId) => {
  const { auth, messaging, firestore } = initFireBase();

  const saveFcmToken = async (hashedVaultId) => {
    try {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js",
      );
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAP_ID,
        serviceWorkerRegistration: registration,
      });
      // console.log("✅ FCM Token:", token);
      const currentToken = token;
      if (!currentToken) {
        console.warn("No FCM token available");
        return;
      }

      const userDoc = doc(
        firestore,
        process.env.REACT_APP_KYC_DB,
        hashedVaultId,
      );
      await setDoc(
        userDoc,
        {
          fcmToken: {
            token: currentToken,
            updatedAt: new Date(),
          },
        },
        { merge: true },
      );
      // console.log("FCM token saved to Firestore....");
      return true;
    } catch (err) {
      console.error("Error saving FCM token:", err);
      return false;
    }
  };

  await saveFcmToken(hashedVaultId);

  onAuthStateChanged(auth, async () => {
    await saveFcmToken(hashedVaultId);
  });
};

// export const saveKycQuestionnaire = async (
//   hashedUserAddress,
//   hashedUserId,
//   kycQuestionnaire,
// ) => {
//   try {
//     await getAndSaveTokenKyc(hashedUserAddress);
//     const { firestore } = initFireBase();
//     const userDoc = doc(
//       firestore,
//       process.env.REACT_APP_KYC_DB,
//       hashedUserAddress,
//     );
//     const userIdHash = await bcrypt.hash(hashedUserId, 10);
//     await setDoc(
//       userDoc,
//       {
//         ...kycQuestionnaire,
//         hashedId: hashedUserAddress,
//         passKeyRefHash: userIdHash,
//       },
//       { merge: true },
//     );
//     return true;
//   } catch (err) {
//     console.error("Error saving new user:", err);
//     return false;
//   }
// };
